import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { api, helper } from '@/utils'
import { ProviderItemViewModel, ScenarioProviderType } from '@/interfaces'
import { getErrorHandler } from './users'
import { ActionCreator } from '../index'

export interface ScenarioProvidersState {
  metalProcessingProvider: ProviderItemViewModel | null
  bladeProcessingProvider: ProviderItemViewModel | null
  concreteProcessingProvider: ProviderItemViewModel | null
}

const initialState: ScenarioProvidersState = {
  metalProcessingProvider: null,
  bladeProcessingProvider: null,
  concreteProcessingProvider: null
}

const { isValidGuid } = helper

export const scenarioProvidersSlice = createSlice({
  name: 'scenarioProviders',
  initialState,
  reducers: {
    setMetalProcessingProvider: (
      state,
      action: PayloadAction<ProviderItemViewModel | null>
    ) => {
      state.metalProcessingProvider = action.payload
    },
    setBladeProcessingProvider: (
      state,
      action: PayloadAction<ProviderItemViewModel | null>
    ) => {
      state.bladeProcessingProvider = action.payload
    },
    setconcreteProcessingProvider: (
      state,
      action: PayloadAction<ProviderItemViewModel | null>
    ) => {
      state.concreteProcessingProvider = action.payload
    }
  }
})

export const { actions } = scenarioProvidersSlice

export const resetProvider: ActionCreator = type => dispatch => {
  if (type === ScenarioProviderType.MetalProcessingProvider)
    dispatch(actions.setMetalProcessingProvider(null))
  if (type === ScenarioProviderType.BladeProcessingProvider)
    dispatch(actions.setBladeProcessingProvider(null))
  if (type === ScenarioProviderType.ConcreteProcessingProvider)
    dispatch(actions.setconcreteProcessingProvider(null))
}

export const getProvider: ActionCreator =
  ({ id, type }) =>
  dispatch => {
    dispatch(resetProvider(type))
    return isValidGuid(id)
      ? api.providers
          .read(id)
          .then((data: ProviderItemViewModel) => {
            if (type === ScenarioProviderType.MetalProcessingProvider)
              dispatch(actions.setMetalProcessingProvider(data))
            if (type === ScenarioProviderType.BladeProcessingProvider)
              dispatch(actions.setBladeProcessingProvider(data))
            if (type === ScenarioProviderType.ConcreteProcessingProvider)
              dispatch(actions.setconcreteProcessingProvider(data))
          })
          .catch(getErrorHandler(dispatch))
      : undefined
  }
